import { useTRPC } from '@/trpc';
import { useMutation } from '@tanstack/react-query';
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import React from 'react'
import * as Icon from 'lucide-react'
import { toast } from 'sonner';
import { TRPCClientError } from '@trpc/client';
import { useAuth } from '@/hooks/use-auth';

interface Props {
    filter_id: string;
    trigger?: React.ReactNode;
    onRemoved?: () => void;
    open?: boolean; 
    onOpenChange?: (open: boolean) => void; 
}

const RemoveFilter = ({ filter_id, trigger, onRemoved, open: externalOpen, onOpenChange }: Props) => {
    const { trpc } = useTRPC();
    const [internalOpen, setInternalOpen] = React.useState(false);

    const open = externalOpen !== undefined ? externalOpen : internalOpen;
    const setOpen = onOpenChange || setInternalOpen;

    const { user } = useAuth();

    interface RemoveFilterData {
        filter_id: string;
    }
    const removeMutation = useMutation({
        mutationFn: async (data:RemoveFilterData) => {
            await trpc.filters.remove.mutate({ user_id: user!.id, ...data })
        },
        onSuccess: () => {
            onRemoved?.();
            setOpen(false);
        },
        onError: (err) => {
            if(err instanceof Error) {
                toast.error(err.message);
            } else if(err instanceof TRPCClientError) {
                toast.error(err.message);
            } else {
                toast.error("Er is een onbekende fout opgetreden.");
            }
        }
    })

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
        {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>Verwijder filter</AlertDialogTitle>
                <AlertDialogDescription>Weet je zeker dat je deze filter wilt verwijderen?</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>Annuleren</AlertDialogCancel>
                <Button
                    variant='destructive'
                    onClick={() => { removeMutation.mutate({ filter_id }) }}
                    disabled={removeMutation.isLoading}
                >
                    {removeMutation.isLoading && <Icon.Loader2 className="w-4 h-4 animate-spin" />}
                    Verwijderen
                </Button>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default RemoveFilter;